/// <amd-module name="Feed/Connect/Protocols/Maven" />
import { replaceRouteValues } from "VSS/Platform/Util/Url";

import { PackagingService } from "Feed/Core/PackagingService";
import { IUxFeedView } from "Feed/Core/UxFeedView";

import { PackagingProcotol } from "../Protocol";
import { PackagingTool, ToolId } from "../Tool";

import * as Res from "Feed/Connect/Resources";

class MavenProtocol extends PackagingProcotol {
    constructor() {
        super("Maven");
    }

    public readonly area = "maven";

    public getFeedUrl(packagingService: PackagingService, feed: IUxFeedView) {
        // TODO: Move route resolution to endpoints within this object
        const path = replaceRouteValues("_packaging/{feed}/{area}/{resource}/{*path}", {
            feed: feed.name,
            area: this.area,
            resource: "v1"
        });

        return packagingService.getUrl(feed.project, path);
    }
}

const MavenP = new MavenProtocol();

class MavenTool extends PackagingTool {
    constructor(id: ToolId, name: string, imageName: string, private toolLinkId: number) {
        super(id, name, MavenP, { src: `ms.feed/feed-connect/Content/${imageName}` });
    }

    public getToolLink = () => ({
        href: `https://go.microsoft.com/fwlink/?linkid=${this.toolLinkId}`,
        children: `${Res.CommandLineReference}`
    });
}

export const Maven = new MavenTool(ToolId.Maven, "Maven", "apache.svg", 2103966);
export const Gradle = new MavenTool(ToolId.Gradle, "Gradle", "gradle.svg", 2103967);
